import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { authloginEndpoints } from "./endpoints";

export const authBaseQuery = fetchBaseQuery({
  baseUrl: `${import.meta.env.VITE_AUTH_BASE_URL}/`,
  credentials: "same-origin",
  prepareHeaders: (headers, { endpoint }) => {
    const endPointsArray = ["signOutUser", "signInUser"];
    headers.set("Content-Type", "application/json");
    if (
      endPointsArray.includes(endpoint) &&
      localStorage.getItem("accessToken")
    ) {
      headers.set(
        "Authorization",
        `Bearer ${localStorage.getItem("accessToken")}`
      );
    }
    return headers;
  }
});

const authApi = createApi({
  reducerPath: "authApi",
  baseQuery: authBaseQuery,
  endpoints: (builder) => ({
    ...authloginEndpoints(builder)
  })
});

export const {
  useSignInUserMutation,
  useVerifyMFAMutation,
  useForcedChangePasswordMutation,
  useSetUpMFAMutation,
  useAuthenticateUserMutation,
  useConfirmChangePasswordUserMutation,
  useChangePasswordUserMutation,
  useLazySignOutUserQuery,
  usePrefetch
} = authApi;

export default authApi;
